const info = 
{
    title: "Mancaved",
    type: "Short Film"
};

export default info;